// @flow strict

import React, { type Node } from 'react';

import * as styles from './blockquote.module.less';

// quote svg icon
const quoteIcon = (
  <svg
    width="46"
    height="35"
    viewBox="0 0 46 35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="rotate(180 23 17.5)">
      <path
        d="M0 0h20.521v17.66c0 2.936-.527 5.374-1.583 7.319-1.056 1.94-2.417 3.553-4.086 4.84a21.667 21.667 0 0 1-5.6 3.095A95.663 95.663 0 0 1 3.122 35L.046 29.497c1.532-.581 2.839-1.17 3.925-1.766 1.088-.597 1.975-1.247 2.663-1.95a6.599 6.599 0 0 0 1.516-2.407c.322-.903.48-1.966.48-3.188H0V0zm25.433 0h20.568v17.66c0 2.936-.528 5.374-1.583 7.319-1.056 1.94-2.426 3.553-4.11 4.84a22.022 22.022 0 0 1-5.624 3.095A95.536 95.536 0 0 1 28.556 35l-3.03-5.503c1.531-.581 2.839-1.17 3.924-1.766 1.088-.597 1.976-1.247 2.663-1.95a6.576 6.576 0 0 0 1.516-2.407c.322-.903.481-1.966.481-3.188h-8.677V0z"
        fill="#F60"
      />
    </g>
  </svg>
);

/**
 * Renders a blockquote in markdown articles.
 *
 * @param props - component props
 *
 * @returns {JSX.Element}
 */
export const Blockquote = ({ children, author }): Node => {
  // check if author has been passed
  const hasAuthor = author != null && author.trim() !== '';

  return (
    <div className={styles.blockquote}>
      <div className={styles.quoteIcon}>{quoteIcon}</div>
      <div>
        <blockquote>{children}</blockquote>
        {hasAuthor && <span>{author}</span>}
      </div>
    </div>
  );
};
